import Alpine from 'alpinejs';

window.Alpine = Alpine;

// Extend Window interface to include notificationBannerVersion
declare global {
  interface Window {
    Alpine: typeof Alpine;
    notificationBannerVersion?: string;
  }
}

interface FeaturedImageNode {
  sourceUrl: string;
  altText: string;
}

interface ConceptNode {
  name: string;
}

interface TripNode {
  id: string;
  title: string;
  uri: string;
  featuredImage?: {
    node: FeaturedImageNode;
  };
  travelConcepts?: {
    nodes: ConceptNode[];
  };
  acfTrip?: {
    listingNotice: string;
    departures: {
      dateDeparture: string;
    }[];
  };
  // computed client-side
  _earliestDepartureMs?: number | null;
  _earliestDepartureText?: string;
}

interface TripEdge {
  cursor: string;
  node: TripNode;
}

interface PageInfo {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string | null;
  endCursor: string | null;
}

const shouldUseTitleOnlySearch = (): boolean => {
  if (typeof window === 'undefined' || typeof window.location === 'undefined') {
    return false;
  }
  const pathname = window.location.pathname || '';
  const normalized = pathname.replace(/\/+$/, '') || '/';
  return normalized === '/loparresor';
};

// type CookieConsentInstance = {
//   init: (config: unknown) => void;
// };

// const cookieConsentConfig = {
//   mode: 'bar',
//   showRejectAllButton: true,
//   theme: {
//     barColor: '#ffffff',
//     barTextColor: '#111827',
//     barMainButtonColor: 'var(--wp--preset--color--primary-600)',
//     barMainButtonTextColor: '#ffffff',
//     modalMainButtonColor: 'var(--wp--preset--color--primary-600)',
//     modalMainButtonTextColor: '#ffffff',
//   },
//   customCSS: `
//     #cconsent-bar {
//       background-color: rgba(255, 255, 255, 0.95);
//       backdrop-filter: blur(12px);
//       -webkit-backdrop-filter: blur(12px);
//       box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
//       border-top: 1px solid rgba(0, 0, 0, 0.05);
//       padding: 1.25rem 2rem;
//       font-family: var(--wp--preset--font-family--inter), sans-serif;
//       color: var(--wp--preset--color--gray-900, #111827);
//     }
//     #cconsent-bar .ccb__wrapper {
//       max-width: var(--wp--preset--layout--wide-size, 1216px);
//       margin: 0 auto;
//       display: flex;
//       align-items: center;
//       justify-content: space-between;
//       gap: 1.5rem;
//     }
//     #cconsent-bar .ccb__left {
//       flex: 1;
//       font-size: 0.9375rem;
//       line-height: 1.5;
//     }
//     #cconsent-bar .ccb__right {
//       display: flex;
//       gap: 0.75rem;
//       align-items: center;
//       flex-shrink: 0;
//     }
//     #cconsent-bar button {
//       font-family: inherit;
//       font-weight: 500;
//       border-radius: 0.375rem;
//       padding: 0.625rem 1.25rem;
//       transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
//       cursor: pointer;
//       font-size: 0.875rem;
//       white-space: nowrap;
//     }
//     #cconsent-bar button.consent-give {
//       background-color: var(--wp--preset--color--primary-600, #2563eb);
//       color: #ffffff;
//       border: 1px solid var(--wp--preset--color--primary-600, #2563eb);
//     }
//     #cconsent-bar button.consent-give:hover {
//       background-color: var(--wp--preset--color--primary-700, #1d4ed8);
//       border-color: var(--wp--preset--color--primary-700, #1d4ed8);
//       transform: translateY(-1px);
//       box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
//     }
//     #cconsent-bar button.consent-decline {
//       background-color: transparent;
//       color: var(--wp--preset--color--gray-700, #374151);
//       border: 1px solid var(--wp--preset--color--gray-300, #d1d5db);
//     }
//     #cconsent-bar button.consent-decline:hover {
//       background-color: var(--wp--preset--color--gray-50, #f9fafb);
//       border-color: var(--wp--preset--color--gray-400, #9ca3af);
//       color: var(--wp--preset--color--gray-900, #111827);
//     }
//     #cconsent-bar button.ccb__edit {
//       background: transparent;
//       border: none;
//       text-decoration: none;
//       color: var(--wp--preset--color--gray-500, #6b7280);
//       padding: 0.5rem;
//       margin-right: 0.5rem;
//       font-weight: 400;
//     }
//     #cconsent-bar button.ccb__edit:hover {
//       color: var(--wp--preset--color--primary-600, #2563eb);
//       text-decoration: underline;
//     }

//     /* Modal Styling */
//     #cconsent-modal {
//       font-family: var(--wp--preset--font-family--inter), sans-serif;
//       background-color: rgba(0, 0, 0, 0.6);
//       backdrop-filter: blur(4px);
//     }
//     #cconsent-modal .ccm__content {
//       border-radius: 0.75rem;
//       box-shadow: var(--wp--preset--shadow--2xl, 0 25px 50px -12px rgba(0, 0, 0, 0.25));
//       overflow: hidden;
//       max-width: 650px;
//     }
//     #cconsent-modal .ccm__content > .ccm__content__heading {
//       background-color: var(--wp--preset--color--white, #fff);
//       border-bottom: 1px solid var(--wp--preset--color--gray-100, #f3f4f6);
//       padding: 2rem;
//     }
//     #cconsent-modal .ccm__content > .ccm__content__heading strong {
//       font-size: 1.25rem;
//       font-weight: 600;
//       color: var(--wp--preset--color--gray-900, #111827);
//     }
//     #cconsent-modal .ccm__content > .ccm__content__heading p {
//       color: var(--wp--preset--color--gray-600, #4b5563);
//       font-size: 0.9375rem;
//       line-height: 1.6;
//     }
//     #cconsent-modal .ccm__content > .ccm__content__body {
//       background-color: var(--wp--preset--color--white, #fff);
//     }
//     #cconsent-modal .ccm__content > .ccm__content__body .ccm__tab-trigger {
//       padding: 1.25rem 2rem;
//       color: var(--wp--preset--color--gray-800, #1f2937);
//       transition: background-color 0.2s;
//     }
//     #cconsent-modal .ccm__content > .ccm__content__body .ccm__tab-trigger:hover {
//       background-color: var(--wp--preset--color--gray-50, #f9fafb);
//     }
//     #cconsent-modal .ccm__footer {
//       background-color: var(--wp--preset--color--gray-50, #f9fafb);
//       padding: 1.5rem 2rem;
//       border-top: 1px solid var(--wp--preset--color--gray-200, #e5e7eb);
//       gap: 0.75rem;
//     }
//     #cconsent-modal .ccm__footer button {
//       border-radius: 0.375rem;
//       padding: 0.75rem 1.25rem;
//       font-weight: 500;
//       height: auto;
//       min-width: unset;
//     }
//     #cconsent-modal .ccm__footer button.ccm__footer__submit {
//       background-color: var(--wp--preset--color--primary-600, #2563eb);
//     }
//     #cconsent-modal .ccm__footer button.ccm__footer__submit:hover {
//       background-color: var(--wp--preset--color--primary-700, #1d4ed8);
//     }
    
//     @media (max-width: 768px) {
//       #cconsent-bar {
//         padding: 1rem;
//       }
//       #cconsent-bar .ccb__wrapper {
//         flex-direction: column;
//         align-items: stretch;
//       }
//       #cconsent-bar .ccb__right {
//         margin-top: 1rem;
//         flex-direction: column;
//         width: 100%;
//       }
//       #cconsent-bar .ccb__right > div {
//         width: 100%;
//         display: flex;
//         flex-direction: column;
//         gap: 0.5rem;
//       }
//       #cconsent-bar button {
//         width: 100%;
//         text-align: center;
//         margin: 0;
//       }
//       #cconsent-bar button.ccb__edit {
//         margin: 0;
//         margin-bottom: 0.5rem;
//         text-align: center;
//       }
//     }
//   `,
//   language: {
//     current: 'sv',
//     locale: {
//       sv: {
//         cookieBarLabel: 'Cookiehantering',
//         barMainText: 'Vi använder cookies för att förbättra din upplevelse på webbplatsen.',
//         closeAriaLabel: 'stäng',
//         barLinkSetting: 'Cookieinställningar',
//         barBtnAcceptAll: 'Acceptera alla cookies',
//         barBtnRejectAll: 'Avvisa alla cookies',
//         modalMainTitle: 'Cookieinställningar',
//         modalMainText: 'Cookies är små textfiler som sparas på din enhet när du besöker en webbplats. Vi använder cookies för att anpassa innehåll, analysera trafik och förbättra våra tjänster.',
//         modalBtnSave: 'Spara nuvarande inställningar',
//         modalBtnAcceptAll: 'Acceptera alla cookies och stäng',
//         modalBtnRejectAll: 'Avvisa alla cookies och stäng',
//         initModalBtnAgree: 'Jag samtycker',
//         initModalBtnDisagree: 'Jag samtycker inte',
//         initModalBtnOptions: 'Hantera alternativ',
//         modalAffectedSolutions: 'Påverkar följande tjänster:',
//         learnMore: 'Läs mer',
//         on: 'På',
//         off: 'Av',
//         enabled: 'är aktiverad.',
//         disabled: 'är inaktiverad.',
//         checked: 'markerad',
//         unchecked: 'omarkerad',
//       },
//     },
//   },
//   categories: {
//     necessary: {
//       needed: true,
//       wanted: true,
//       checked: true,
//       language: {
//         locale: {
//           sv: {
//             name: 'Nödvändiga cookies',
//             description: 'Dessa cookies är nödvändiga för att webbplatsen ska fungera korrekt och kan inte stängas av i våra system.',
//           },
//         },
//       },
//     },
//     analytics: {
//       needed: false,
//       wanted: false,
//       checked: false,
//       language: {
//         locale: {
//           sv: {
//             name: 'Analyscookies',
//             description: 'Analyscookies hjälper oss att förstå hur webbplatsen används så att vi kan förbättra innehåll och funktioner.',
//           },
//         },
//       },
//     },
//   },
// };

// const initializeCookieConsent = () => {
//   const cookieConsent = (window as Window & { CookieConsent?: CookieConsentInstance }).CookieConsent;

//   if (!cookieConsent || typeof cookieConsent.init !== 'function') {
//     return;
//   }

//   try {
//     cookieConsent.init(cookieConsentConfig);
//   } catch {
//     // Fail silently if CookieConsent.init throws for any reason.
//   }
// };

function getArrayParam(param: string): string[] {
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get(param);
  return value ? value.split(',').filter(Boolean) : [];
}

function getStringParam(param: string): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get(param);
  return value ? value : null;
}

function setArrayParam(param: string, arr: string[]) {
  const url = new URL(window.location.href);
  if (arr.length > 0) {
    url.searchParams.set(param, arr.join(','));
  } else {
    url.searchParams.delete(param);
  }
  window.history.replaceState({}, '', url.toString());
}

function setStringParam(param: string, value: string | null, usePushState = false, state: Record<string, unknown> = {}) {
  const url = new URL(window.location.href);
  if (value && value.length > 0) {
    url.searchParams.set(param, value);
  } else {
    url.searchParams.delete(param);
  }
  if (usePushState) {
    window.history.pushState(state, '', url.toString());
  } else {
    window.history.replaceState(state, '', url.toString());
  }
}

type TripsFilterOptions = {
  defaultCategories?: string[];
  lockCategories?: boolean;
  hideCategoryFilter?: boolean;
  defaultConcepts?: string[];
  lockConcepts?: boolean;
  hideConceptFilter?: boolean;
  defaultSort?: string;
};

function tripsFilter(options: TripsFilterOptions = {}) {
  const defaultCategories = Array.isArray(options.defaultCategories) ? options.defaultCategories.filter((slug): slug is string => typeof slug === 'string' && slug.length > 0) : [];
  const lockCategories = typeof options.lockCategories === 'boolean' ? options.lockCategories : false;
  const hideCategoryFilter = typeof options.hideCategoryFilter === 'boolean' ? options.hideCategoryFilter : false;
  const defaultConcepts = Array.isArray(options.defaultConcepts) ? options.defaultConcepts.filter((slug): slug is string => typeof slug === 'string' && slug.length > 0) : [];
  const lockConcepts = typeof options.lockConcepts === 'boolean' ? options.lockConcepts : false;
  const hideConceptFilter = typeof options.hideConceptFilter === 'boolean' ? options.hideConceptFilter : false;
  const defaultSort = typeof options.defaultSort === 'string' ? (options.defaultSort as 'TITLE_ASC' | 'DATE_DESC' | 'DATE_ASC') : 'TITLE_ASC';

  return {
    posts: [] as TripNode[],
    bootstrapLoaded: false as boolean,
    isLoading: false,
    showSkeleton: false as boolean,
    hasLoadedInitial: false as boolean,
    selectedCategories: [] as string[],
    selectedConcepts: [] as string[],
    selectedInstructors: [] as string[],
    defaultCategories,
    lockCategories,
    hideCategoryFilter,
    defaultConcepts,
    lockConcepts,
    hideConceptFilter,
    defaultSort,
    searchQuery: '' as string,
    sortKey: defaultSort,
    pageSize: 24 as number,
    currentCursor: null as string | null,
    currentPage: 1 as number,
    pageInfo: {
      hasNextPage: false,
      hasPreviousPage: false,
      startCursor: null,
      endCursor: null,
    } as PageInfo,
    navigationHistory: [] as string[],

    init(this) {
      // Läs ev. serverrenderad bootstrap-data från blocket
      const bootstrapScript = (this as any).$root?.querySelector?.('script[data-trips-bootstrap]');
      if (bootstrapScript?.textContent) {
        try {
          const data = JSON.parse(bootstrapScript.textContent);
          if (Array.isArray(data?.items)) {
            this.posts = data.items as TripNode[];
          }
          if (data?.pageInfo) {
            this.pageInfo = {
              hasNextPage: !!data.pageInfo.hasNextPage,
              hasPreviousPage: !!data.pageInfo.hasPreviousPage,
              startCursor: null,
              endCursor: null,
            };
            this.currentPage = data.pageInfo.currentPage ?? this.currentPage;
            this.pageSize = data.pageInfo.perPage ?? this.pageSize;
          }
          if (Array.isArray(data?.selectedCategories)) {
            this.selectedCategories = data.selectedCategories;
          }
          if (Array.isArray(data?.selectedConcepts)) {
            this.selectedConcepts = data.selectedConcepts;
          }
          if (typeof data?.searchQuery === 'string') {
            this.searchQuery = data.searchQuery;
          }
          if (typeof data?.sortKey === 'string') {
            this.sortKey = data.sortKey as typeof this.sortKey;
          }
          this.hasLoadedInitial = true;
          this.bootstrapLoaded = true;
        } catch (e) {
          console.warn('Kunde inte läsa bootstrap-data', e);
        }
      }

      // Hide SSR content after Alpine hydration (always, regardless of bootstrap)
      const ssrContainer = (this as any).$root?.querySelector?.('[data-ssr-posts]');
      if (ssrContainer) ssrContainer.setAttribute('style', 'display:none');
      const ssrPagination = (this as any).$root?.querySelector?.('[data-ssr-pagination]');
      if (ssrPagination) ssrPagination.setAttribute('style', 'display:none');

      const urlCategories = this.lockCategories ? this.defaultCategories : getArrayParam('travelcategory');
      this.selectedCategories = urlCategories.length > 0 ? Array.from(new Set(urlCategories)) : [...this.defaultCategories];
      // Always use default concepts if they exist, otherwise allow URL params
      this.selectedConcepts = this.defaultConcepts.length > 0 ? [...this.defaultConcepts] : getArrayParam('travelconcept');
      this.selectedInstructors = getArrayParam('instructor');
      this.currentCursor = getStringParam('cursor');
      this.searchQuery = getStringParam('q') ?? '';
      this.sortKey = (getStringParam('sort') as 'TITLE_ASC' | 'DATE_DESC' | 'DATE_ASC') ?? this.defaultSort ?? 'TITLE_ASC';
      const pageNumStr = getStringParam('pagenum');
      this.currentPage = pageNumStr ? Math.max(1, parseInt(pageNumStr, 10) || 1) : 1;

      // Sync sort param to URL so it reflects the active sort on initial load
      if (this.sortKey && this.sortKey !== 'TITLE_ASC') {
        setStringParam('sort', this.sortKey);
      }

      const after = this.currentCursor ?? null;
      if (!this.bootstrapLoaded) {
        this.fetchPosts({ first: this.pageSize, after, scrollTop: false });
      } else {
        // Bootstrap data needs client-side post-processing (compute departure
        // dates, filter past trips, sort by ACF departure date)
        this.processAndSortPosts();
      }

      // Watch for changes
      if (!this.lockCategories) {
        // @ts-expect-error: Alpine magic property
        this.$watch('selectedCategories', () => {
          setArrayParam('travelcategory', this.selectedCategories);
          this.currentPage = 1;
          this.resetPagination();
          this.fetchPosts({ first: this.pageSize, after: null, scrollTop: true });
        });
      } else {
        // Keep categories locked to defaults if someone tries to mutate them
        // @ts-expect-error: Alpine magic property
        this.$watch('selectedCategories', (value: string[]) => {
          const normalized = Array.from(new Set(this.defaultCategories));
          const differs = value.length !== normalized.length || normalized.some((slug) => !value.includes(slug));
          if (differs) {
            this.selectedCategories = normalized;
          }
        });
      }

      // Only allow concept changes if no default concepts are set
      if (this.defaultConcepts.length === 0) {
        // @ts-expect-error: Alpine magic property
        this.$watch('selectedConcepts', () => {
          setArrayParam('travelconcept', this.selectedConcepts);
          this.currentPage = 1;
          this.resetPagination();
          this.fetchPosts({ first: this.pageSize, after: null, scrollTop: true });
        });
      } else {
        // Keep concepts locked to defaults if default concepts are set
        // @ts-expect-error: Alpine magic property
        this.$watch('selectedConcepts', (value: string[]) => {
          const normalized = Array.from(new Set(this.defaultConcepts));
          const differs = value.length !== normalized.length || normalized.some((slug) => !value.includes(slug));
          if (differs) {
            this.selectedConcepts = normalized;
          }
        });
      }

      // @ts-expect-error: Alpine magic property
      this.$watch('selectedInstructors', () => {
        setArrayParam('instructor', this.selectedInstructors);
        this.currentPage = 1;
        this.resetPagination();
        this.fetchPosts({ first: this.pageSize, after: null, scrollTop: true });
      });

      // @ts-expect-error: Alpine magic property
      this.$watch('searchQuery', () => {
        setStringParam('q', this.searchQuery);
        this.currentPage = 1;
        this.resetPagination();
        this.fetchPosts({ first: this.pageSize, after: null, scrollTop: true });
      });

      // @ts-expect-error: Alpine magic property
      this.$watch('sortKey', () => {
        setStringParam('sort', this.sortKey);
        this.currentPage = 1;
        this.resetPagination();
        this.fetchPosts({ first: this.pageSize, after: null, scrollTop: true });
      });

      // Handle browser navigation (back/forward)
      window.addEventListener('popstate', (event: PopStateEvent) => {
        type HistoryState = { pagination?: { after?: string | null; before?: string | null } };
        const state = (event.state || {}) as HistoryState;
        const urlCategories = getArrayParam('travelcategory');
        const urlConcepts = getArrayParam('travelconcept');
        const urlInstructors = getArrayParam('instructor');
        const urlCursor = getStringParam('cursor');
        const urlQ = getStringParam('q') ?? '';
        const urlSort = (getStringParam('sort') as 'TITLE_ASC' | 'DATE_DESC') ?? 'TITLE_ASC';
        const urlPage = getStringParam('pagenum');
        this.selectedCategories = urlCategories;
        this.selectedConcepts = urlConcepts;
        this.selectedInstructors = urlInstructors;
        this.currentCursor = urlCursor;
        this.searchQuery = urlQ;
        this.sortKey = urlSort;
        this.currentPage = urlPage ? Math.max(1, parseInt(urlPage, 10) || 1) : 1;

        const pagination = state?.pagination || {};
        const after = typeof pagination.after === 'string' ? pagination.after : (this.currentCursor ?? null);
        const before = typeof pagination.before === 'string' ? pagination.before : null;

        this.fetchPosts({ first: after ? this.pageSize : undefined, after, last: before ? this.pageSize : undefined, before });
      });

      // Infinite scroll via IntersectionObserver
      // @ts-expect-error: Alpine $refs is dynamic
      this.$nextTick(() => {
        // @ts-expect-error: Alpine $refs typing
        const sentinel: HTMLElement | undefined = this.$refs?.sentinel;
        if (!sentinel || !(window as any).IntersectionObserver) return;
        const io = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting) {
                if (!this.isLoading && this.pageInfo?.hasNextPage) {
                  this.loadNextPage();
                }
              }
            }
          },
          { root: null, rootMargin: '800px 0px', threshold: 0 },
        );
        io.observe(sentinel);
      });
    },

    processAndSortPosts() {
      const parseDateToMs = (value: string | undefined | null): number | null => {
        if (!value || typeof value !== 'string') return null;
        const MIN_MS = Date.UTC(2000, 0, 1);
        const t = Date.parse(value);
        if (!Number.isNaN(t)) return t >= MIN_MS ? t : null;
        const ymd = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
        if (ymd) {
          const ms = Date.UTC(Number(ymd[1]), Number(ymd[2]) - 1, Number(ymd[3]));
          return Number.isFinite(ms) && ms >= MIN_MS ? ms : null;
        }
        const ymdCompact = /^(\d{4})(\d{2})(\d{2})$/.exec(value);
        if (ymdCompact) {
          const ms = Date.UTC(Number(ymdCompact[1]), Number(ymdCompact[2]) - 1, Number(ymdCompact[3]));
          return Number.isFinite(ms) && ms >= MIN_MS ? ms : null;
        }
        return null;
      };

      const computeEarliest = (post: TripNode): number | null => {
        const dates = (post?.acfTrip?.departures || []).map((dep) => parseDateToMs(dep?.dateDeparture)).filter((ms): ms is number => typeof ms === 'number' && Number.isFinite(ms));
        return dates.length === 0 ? null : Math.min(...dates);
      };

      const formatFromMs = (ms: number): string =>
        this.formatDepartureDate(new Date(ms).toISOString());

      this.posts = this.posts.map((p) => {
        const earliest = computeEarliest(p);
        p._earliestDepartureMs = earliest;
        p._earliestDepartureText = typeof earliest === 'number' ? formatFromMs(earliest) : '';
        return p;
      });

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const todayMs = today.getTime();
      this.posts = this.posts.filter((p) => {
        const earliestMs = p._earliestDepartureMs;
        return earliestMs === null || earliestMs === undefined || earliestMs >= todayMs;
      });

      if (this.sortKey === 'TITLE_ASC') {
        this.posts = [...this.posts].sort((a, b) => {
          const titleA = (a.title || '').toLowerCase();
          const titleB = (b.title || '').toLowerCase();
          return titleA.localeCompare(titleB, 'sv');
        });
      } else if (this.sortKey === 'DATE_ASC' || this.sortKey === 'DATE_DESC') {
        this.posts = [...this.posts].sort((a, b) => {
          const missingAsc = Number.POSITIVE_INFINITY;
          const missingDesc = Number.NEGATIVE_INFINITY;
          const da = typeof a._earliestDepartureMs === 'number' ? a._earliestDepartureMs : this.sortKey === 'DATE_ASC' ? missingAsc : missingDesc;
          const db = typeof b._earliestDepartureMs === 'number' ? b._earliestDepartureMs : this.sortKey === 'DATE_ASC' ? missingAsc : missingDesc;
          return this.sortKey === 'DATE_ASC' ? da - db : db - da;
        });
      }
    },

    async fetchPosts({ first, after, last, before, pushHistory = false, append = false, scrollTop = false }: { first?: number; after?: string | null; last?: number; before?: string | null; pushHistory?: boolean; append?: boolean; scrollTop?: boolean } = {}) {
      if (this.isLoading) return;
      this.isLoading = true;

      // Always fetch initial page to enable infinite scroll even for TITLE_ASC

      const taxArray = [];

      if (this.selectedCategories.length > 0) {
        taxArray.push({ taxonomy: 'TRAVELCATEGORY', field: 'SLUG', terms: this.selectedCategories, operator: 'IN' });
      }

      if (this.selectedConcepts.length > 0) {
        taxArray.push({ taxonomy: 'TRAVELCONCEPT', field: 'SLUG', terms: this.selectedConcepts, operator: 'IN' });
      }

      const query = /* GraphQL */ `
        query GetTrips($first: Int, $after: String, $last: Int, $before: String, $taxArray: [TaxArray], $search: String, $orderby: [PostObjectsConnectionOrderbyInput], $language: String) {
          trips(first: $first, after: $after, last: $last, before: $before, where: {
            taxQuery: {
              relation: AND,
              taxArray: $taxArray
            }
            ${
              Array.from(this.selectedInstructors).length > 0
                ? 'metaQuery: {relation: OR, metaArray: [' +
                  Array.from(this.selectedInstructors)
                    .map((id) => `{value: "${id}", key: "instructors", compare: LIKE}`)
                    .join(', ') +
                  ']}'
                : ''
            },
            search: $search,
            orderby: $orderby,
            language: $language
          })
          {
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
            }
            edges {
              cursor
              node {
                id
                title
                uri
                featuredImage {
                  node {
                    sourceUrl
                    altText
                  }
                }
                travelConcepts {
                  nodes {
                    name
                  }
                }
                ... on WithAcfAcfTrip {
                  acfTrip {
                    listingNotice
                    departures {
                      dateDeparture
                    }
                  }
                }
              }
            }
          }
        }
      `;

      const variables: Record<string, unknown> = {
        taxArray: taxArray,
        first: typeof first === 'number' ? first : undefined,
        after: after ?? undefined,
        last: typeof last === 'number' ? last : undefined,
        before: before ?? undefined,
        search: this.searchQuery && this.searchQuery.length > 0 ? this.searchQuery : undefined,
        // OBS: WPGraphQL i denna miljö stödjer ej META_VALUE_NUM/metaKey i orderby.
        // Vi använder DATE för server-sidan och korrigerar ordningen klient-side efter ACF-datum.
        orderby: this.sortKey === 'TITLE_ASC' ? [{ field: 'TITLE', order: 'ASC' }] : [{ field: 'DATE', order: this.sortKey === 'DATE_ASC' ? 'ASC' : 'DESC' }],
        language: siteConfig.currentLang || undefined,
      };

      console.log('GraphQL Query:', query);
      console.log('GraphQL Variables:', JSON.stringify(variables, null, 2));

      try {
        // Använd REST för alla sorteringar för konsekvent beteende
        if (this.sortKey === 'DATE_ASC' || this.sortKey === 'DATE_DESC' || this.sortKey === 'TITLE_ASC') {
          const restrictSearchToTitle = shouldUseTitleOnlySearch();
          const params = new URLSearchParams();
          params.set('page', String(this.currentPage));
          params.set('per_page', String(first || this.pageSize));

          if (this.sortKey === 'TITLE_ASC') {
            // För TITLE_ASC, använd standard WP sortering (title ASC)
            params.set('order', 'ASC');
            params.set('orderby', 'title');
          } else if (this.sortKey === 'DATE_ASC' || this.sortKey === 'DATE_DESC') {
            // För datum-sortering
            const order = this.sortKey === 'DATE_ASC' ? 'ASC' : 'DESC';
            params.set('order', order);
            params.set('orderby', 'date');
          }

          if (this.searchQuery) params.set('q', this.searchQuery);
          if (this.selectedCategories.length) params.set('travelcategory', this.selectedCategories.join(','));
          if (this.selectedConcepts.length) params.set('travelconcept', this.selectedConcepts.join(','));
          if (restrictSearchToTitle) params.set('search_title_only', '1');
          // Include current language for proper filtering
          if (siteConfig.currentLang) params.set('lang', siteConfig.currentLang);
          const restUrl = `${siteConfig.restUrl}brainforest/v1/trips?${params.toString()}`;
          const resp = await fetch(restUrl, { headers: { Accept: 'application/json' } });
          const data = await resp.json();
          const newItems = (data?.items || []) as TripNode[];
          if (append) {
            const seen = new Set(this.posts.map((p) => p.id));
            const merged = [...this.posts];
            for (const it of newItems) {
              if (!seen.has(it.id)) {
                merged.push(it);
              }
            }
            this.posts = merged;
          } else {
            this.posts = newItems;
          }
          const pi = data?.pageInfo || {};
          this.pageInfo = {
            hasNextPage: !!pi.hasNextPage,
            hasPreviousPage: !!pi.hasPreviousPage,
            startCursor: null,
            endCursor: null,
          };
          this.hasLoadedInitial = true;
        } else {
          const response = await fetch(siteConfig.graphqlUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ query, variables }),
          });
          const json = await response.json();
          if (json.errors) {
            console.error('GraphQL Errors:', json.errors);
          }
          const trips = json?.data?.trips;
          const edges: TripEdge[] = trips?.edges || [];
          const newItems = edges.map((edge: TripEdge) => edge.node) || [];
          if (append) {
            const seen = new Set(this.posts.map((p) => p.id));
            const merged = [...this.posts];
            for (const it of newItems) {
              if (!seen.has(it.id)) {
                merged.push(it);
              }
            }
            this.posts = merged;
          } else {
            this.posts = newItems;
          }
          this.pageInfo = trips?.pageInfo || { hasNextPage: false, hasPreviousPage: false, startCursor: null, endCursor: null };
          this.hasLoadedInitial = true;
        }

        this.processAndSortPosts();

        // Debug logging removed
        this.currentCursor = this.pageInfo?.endCursor ?? null;

        if (pushHistory) {
          const usedCursor = typeof after === 'string' && after.length > 0 ? after : typeof before === 'string' && before.length > 0 ? before : '';
          const state = {
            pagination: {
              after: typeof after === 'string' ? after : null,
              before: typeof before === 'string' ? before : null,
            },
          };
          setStringParam('cursor', usedCursor, true, state);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        this.posts = [];
        this.pageInfo = { hasNextPage: false, hasPreviousPage: false, startCursor: null, endCursor: null };
      } finally {
        this.hasLoadedInitial = true;
        this.isLoading = false;
        // No automatic scroll to top to avoid jumps
      }
    },

    hasActiveFilters() {
      const categoriesActive = this.lockCategories ? this.selectedCategories.length !== this.defaultCategories.length || this.selectedCategories.some((cat) => !this.defaultCategories.includes(cat)) : this.selectedCategories.length > 0;
      return categoriesActive || this.selectedConcepts.length > 0 || this.selectedInstructors.length > 0 || this.searchQuery.length > 0;
    },

    loadNextPage() {
      if (this.isLoading) return;
      if (!this.pageInfo?.hasNextPage) return;
      this.currentPage = (this.currentPage || 1) + 1;
      // Ingen URL-uppdatering för infinite scroll; appenda resultat
      this.fetchPosts({ append: true });
    },

    loadPreviousPage() {
      if (this.isLoading) return;
      if (this.sortKey === 'DATE_ASC' || this.sortKey === 'DATE_DESC') {
        if (!this.pageInfo?.hasPreviousPage) return;
        this.currentPage = Math.max(1, (this.currentPage || 1) - 1);
        setStringParam('pagenum', String(this.currentPage), true);
        this.fetchPosts({});
        return;
      }
      if (!this.pageInfo?.hasPreviousPage || !this.pageInfo?.startCursor) return;
      const beforeCursor = this.pageInfo.startCursor;
      this.fetchPosts({ last: this.pageSize, before: beforeCursor, pushHistory: true });
    },

    resetPagination() {
      this.currentCursor = null;
      this.navigationHistory = [];
      this.pageInfo = { hasNextPage: false, hasPreviousPage: false, startCursor: null, endCursor: null };
      setStringParam('cursor', null);
    },

    resetFilters() {
      this.selectedCategories = this.lockCategories ? [...this.defaultCategories] : [];
      this.selectedConcepts = [];
      this.selectedInstructors = [];
      this.searchQuery = '';
      this.sortKey = this.defaultSort ?? 'TITLE_ASC';
      if (!this.lockCategories) {
        setArrayParam('travelcategory', []);
      }
      setArrayParam('travelconcept', []);
      setArrayParam('instructor', []);
      setStringParam('q', null);
      setStringParam('sort', null);
      this.posts = [];
      this.resetPagination();
    },

    clearSearch() {
      this.searchQuery = '';
    },

    formatDepartureDate(isoDate: string): string {
      const date = new Date(isoDate);
      // Month names come from the server so the date reads in the visitor's
      // language; the Swedish list is only a fallback if that is missing.
      const months =
        siteConfig.monthsShort && siteConfig.monthsShort.length === 12
          ? siteConfig.monthsShort
          : ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      return `${day} ${month} ${year}`;
    },

    getEarliestDepartureMs(post: TripNode): number | null {
      const toMs = (value?: string): number | null => {
        if (!value) return null;
        const MIN_MS = Date.UTC(2000, 0, 1);
        const parsed = Date.parse(value);
        if (!Number.isNaN(parsed)) return parsed >= MIN_MS ? parsed : null;
        const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value) || /^(\d{4})(\d{2})(\d{2})$/.exec(value);
        if (!m) return null;
        const y = Number(m[1]);
        const mo = Number(m[2]);
        const d = Number(m[3]);
        const ms = Date.UTC(y, mo - 1, d);
        return Number.isFinite(ms) && ms >= MIN_MS ? ms : null;
      };
      const dates = (post?.acfTrip?.departures || []).map((dep) => toMs(dep?.dateDeparture)).filter((ms): ms is number => typeof ms === 'number' && Number.isFinite(ms));
      if (dates.length === 0) return null;
      return Math.min(...dates);
    },

    getEarliestDepartureText(post: TripNode): string {
      const ms = this.getEarliestDepartureMs(post);
      if (ms === null) return '';
      // Reuse the formatter so the month names stay localised in one place.
      return this.formatDepartureDate(new Date(ms).toISOString());
    },
  };
}

export default {
  init() {
    // JavaScript to be fired on all pages

    // initializeCookieConsent();

    Alpine.data('tripsFilter', tripsFilter);

    // Initialize mobile menu store
    Alpine.store('mobileMenu', {
      open: false,
    });

    Alpine.start();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Add sticky class when sticky-menu becomes sticky
    const stickyMenu = document.getElementById('sticky-menu');
    if (stickyMenu) {
      const handleScroll = () => {
        if (stickyMenu.getBoundingClientRect().top <= 64) {
          stickyMenu.classList.add('is-sticky');
        } else {
          stickyMenu.classList.remove('is-sticky');
        }
      };
      window.addEventListener('scroll', handleScroll);
      handleScroll();
    }

    const faqSections = document.querySelectorAll('.schema-faq-section');
    faqSections.forEach((faqSection) => {
      const faqQuestion = faqSection.querySelector('.schema-faq-question');
      if (faqQuestion) {
        faqQuestion.addEventListener('click', () => {
          faqSection.classList.toggle('active');
        });
      }
    });

    const banner = document.getElementById('notification-banner');
    const dismissBtn = document.getElementById('notification-banner-dismiss');

    const version = window.notificationBannerVersion;
    const STORAGE_KEY = `notificationBannerDismissed_${version}`;

    // Hide banner if previously dismissed
    if (localStorage.getItem(STORAGE_KEY) === 'true') {
      if (banner) banner.style.display = 'none';
    }

    // Dismiss logic
    dismissBtn?.addEventListener('click', () => {
      localStorage.setItem(STORAGE_KEY, 'true');
      if (banner) banner.style.display = 'none';
    });
  },
};
